export function injectPingdom(url, { docRef = document } = {}) {
  const script = docRef.createElement('script')
  script.async = true
  script.src = url
  const firstScript = docRef.getElementsByTagName('script')[0]
  firstScript.parentNode.insertBefore(script, firstScript)
}
